import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { graphql } from "gatsby";

//docs:
//https://www.gatsbyjs.com/plugins/gatsby-plugin-image/
//https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-plugin-image/
const Image = (props) => {
  const { imageData, objectFit = "cover", sizes = "100vw", quality = 100, width = null } = props;

  const image = getImage(imageData);
  //add 100% height and width to let its container deciding its display
  //todo: check if the objectFit contain works
  return (
    <GatsbyImage
      objectFit={objectFit}
      image={image}
      alt={imageData?.title ?? "Image"}
      sizes={sizes}
      quality={quality}
      width={width}
      style={objectFit === "cover" ? { height: "100%", width: "100%" } : null}
    />
  );
};

export default Image;

/**
 * 
  The gatsby-plugin-image provides three layout types:
  FIXED: Use this for images with a fixed size. (When showing image not a full width image)
  FLUID (or FULL_WIDTH in newer versions): Use this for images that stretch across the full width of the container. (showing image to be full width)
  CONSTRAINED: Use this for images that have a maximum width but can scale down.
 */
export const query = graphql`
  fragment ImageFixed on ContentfulAsset {
    title
    gatsbyImageData(layout: FIXED, placeholder: NONE, quality: 100, formats: [AUTO, WEBP, AVIF], breakpoints: [400, 800, 1200, 1600, 2510])
  }
  fragment ImageFluid on ContentfulAsset {
    title
    gatsbyImageData(
      layout: FULL_WIDTH
      placeholder: NONE
      quality: 100
      formats: [AUTO, WEBP, AVIF]
      breakpoints: [400, 800, 1200, 1600, 2510]
      width: 1200
    )
  }
  fragment ImageConstrained on ContentfulAsset {
    title
    gatsbyImageData(
      layout: CONSTRAINED
      placeholder: NONE
      quality: 100
      formats: [AUTO, WEBP, AVIF]
      breakpoints: [400, 800, 1200, 1600, 2510]
      height: 200
    )
  }
`;
